import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
        
        // Check for updates less frequently and only when page becomes visible
        // This prevents rapid refreshing during active use
        let updateInterval = null;
        
        const checkForUpdates = () => {
          if (document.visibilityState === 'visible') {
            registration.update().catch((err) => {
              console.warn('SW update check failed (non-critical):', err);
            });
          }
        };
        
        // DISABLED: Automatic update checks to prevent refresh loops
        // The service worker will update naturally when the user refreshes the page
        // or navigates away and comes back
        
        // Uncomment below if you want periodic update checks (after fixing SW update handling)
        /*
        // Check for updates when page becomes visible (user returns to tab)
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            checkForUpdates();
          }
        });
        
        // Check for updates periodically, but less frequently (every 30 minutes)
        // Only check when page is visible
        updateInterval = setInterval(() => {
          if (document.visibilityState === 'visible') {
            checkForUpdates();
          }
        }, 1800000); // Check every 30 minutes
        */
        
        // Cleanup on page unload
        window.addEventListener('beforeunload', () => {
          if (updateInterval) {
            clearInterval(updateInterval);
          }
        });
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
} 